import { render, staticRenderFns } from "./WaitingPositionForm.vue?vue&type=template&id=22e0ceac&scoped=true&"
import script from "./WaitingPositionForm.vue?vue&type=script&lang=js&"
export * from "./WaitingPositionForm.vue?vue&type=script&lang=js&"
import style0 from "./WaitingPositionForm.vue?vue&type=style&index=0&id=22e0ceac&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22e0ceac",
  null
  
)

export default component.exports